/**
 * Logos de las marcas que se muestran en la cinta de la portada.
 *
 * Es una lista fija, a mano: Random informa la marca como texto, no trae logo.
 * Una marca que no esta aca no sale en la cinta aunque se venda; para sumarla
 * se deja el archivo en `public/marcas/` (WebP, recortado al borde, 112 px de
 * alto como maximo) y se agrega su fila con las medidas reales del archivo.
 *
 * `nombres` son las formas en que la marca puede llegar del catalogo (Random y
 * la semilla no la escriben igual: "STARRETT" / "Starret", "HAFELE" /
 * "HÄFELE"). Se comparan sin tildes, mayusculas ni signos, y el logo solo sale
 * mientras la marca tenga algun producto publicado.
 */

export interface LogoMarca {
  /** Nombre para el texto alternativo. */
  nombre: string;
  archivo: string;
  ancho: number;
  alto: number;
  nombres: string[];
}

export const LOGOS_MARCAS: LogoMarca[] = [
  { nombre: 'Albras', archivo: 'albras.webp', ancho: 360, alto: 85, nombres: ['ALBRAS'] },
  { nombre: 'Arauco', archivo: 'arauco.webp', ancho: 360, alto: 58, nombres: ['ARAUCO'] },
  { nombre: 'Artecola', archivo: 'artecola.webp', ancho: 360, alto: 105, nombres: ['ARTECOLA'] },
  {
    nombre: 'Black+Decker',
    archivo: 'black-decker.webp',
    ancho: 360,
    alto: 40,
    nombres: ['B&D', 'BLACK & DECKER', 'BLACK+DECKER'],
  },
  { nombre: 'DeWalt', archivo: 'dewalt.webp', ancho: 360, alto: 111, nombres: ['DEWALT'] },
  { nombre: 'Dideval', archivo: 'dideval.webp', ancho: 360, alto: 100, nombres: ['DIDEVAL'] },
  { nombre: 'Ducasse', archivo: 'ducasse.webp', ancho: 330, alto: 112, nombres: ['DUCASSE'] },
  { nombre: 'Fandeli', archivo: 'fandeli.webp', ancho: 360, alto: 74, nombres: ['FANDELI'] },
  { nombre: 'Frezite', archivo: 'frezite.webp', ancho: 360, alto: 68, nombres: ['FREZITE'] },
  { nombre: 'Häfele', archivo: 'hafele.webp', ancho: 360, alto: 59, nombres: ['HAFELE'] },
  { nombre: 'Henkel', archivo: 'henkel.webp', ancho: 201, alto: 112, nombres: ['HENKEL'] },
  { nombre: 'IFAM', archivo: 'ifam.webp', ancho: 167, alto: 112, nombres: ['IFAM'] },
  { nombre: 'Inchalam', archivo: 'inchalam.webp', ancho: 360, alto: 61, nombres: ['INCHALAM'] },
  { nombre: 'Indaux', archivo: 'indaux.webp', ancho: 360, alto: 89, nombres: ['INDAUX'] },
  { nombre: 'Irwin', archivo: 'irwin.webp', ancho: 297, alto: 112, nombres: ['IRWIN'] },
  { nombre: 'Keter', archivo: 'keter.webp', ancho: 300, alto: 112, nombres: ['KETER'] },
  { nombre: 'Klingspor', archivo: 'klingspor.webp', ancho: 112, alto: 112, nombres: ['KLINGSPOR'] },
  { nombre: 'Kseibi', archivo: 'kseibi.webp', ancho: 360, alto: 68, nombres: ['KSEIBI'] },
  { nombre: 'Leitz', archivo: 'leitz.webp', ancho: 112, alto: 112, nombres: ['LEITZ'] },
  { nombre: 'Makita', archivo: 'makita.webp', ancho: 347, alto: 112, nombres: ['MAKITA'] },
  {
    nombre: 'Brüder Mannesmann',
    archivo: 'mannesmann.webp',
    ancho: 360,
    alto: 53,
    nombres: ['MANNESMAN', 'MANNESMANN'],
  },
  { nombre: 'Norton', archivo: 'norton.webp', ancho: 238, alto: 112, nombres: ['NORTON'] },
  { nombre: 'Olfa', archivo: 'olfa.webp', ancho: 360, alto: 96, nombres: ['OLFA'] },
  { nombre: 'Passol', archivo: 'passol.webp', ancho: 121, alto: 112, nombres: ['PASSOL'] },
  {
    nombre: 'Porter-Cable',
    archivo: 'porter-cable.webp',
    ancho: 360,
    alto: 41,
    nombres: ['PORTER CABLE'],
  },
  { nombre: 'Sipa', archivo: 'sipa.webp', ancho: 111, alto: 112, nombres: ['SIPA'] },
  { nombre: 'Stanley', archivo: 'stanley.webp', ancho: 360, alto: 54, nombres: ['STANLEY'] },
  {
    nombre: 'Starrett',
    archivo: 'starrett.webp',
    ancho: 360,
    alto: 85,
    nombres: ['STARRETT', 'STARRET'],
  },
];
